import { http } from "./http";

/** IPPBX → Routing: which countries/regions PBX extensions may call. */

export interface CountryRules {
  countryCode: string;
  countryName: string;
  /** Prefixes within the country that may be called ("" = whole country). */
  allow: string[];
  /** Prefixes within the country that are specifically blocked. */
  deny: string[];
  modifiedUtc: string;
}

export interface RoutingCountry {
  countryId: number;
  name: string;
  iso2: string;
  accessCode: string;
}

export interface RouteCheckResult {
  number: string;
  allowed: boolean;
  reason: "ALLOWED" | "DENIED_BY_RULE" | "NO_RULE" | string;
  scope?: "global" | "customer" | null;
  countryCode?: string | null;
  countryName?: string | null;
  prefix?: string | null;
  action?: "allow" | "deny" | null;
}

const base = "/api/ippbx/routing";

export const pbxRoutingApi = {
  global: () => http<CountryRules[]>(`${base}/global`),
  saveGlobal: (countryCode: string, body: { countryName: string; allow: string[]; deny: string[] }) =>
    http<CountryRules[]>(`${base}/global/${encodeURIComponent(countryCode)}`, { method: "PUT", body: JSON.stringify(body) }),
  deleteGlobal: (countryCode: string) => http<CountryRules[]>(`${base}/global/${encodeURIComponent(countryCode)}`, { method: "DELETE" }),

  customer: (customerId: number) => http<CountryRules[]>(`${base}/customers/${customerId}`),
  saveCustomer: (customerId: number, countryCode: string, body: { countryName: string; allow: string[]; deny: string[] }) =>
    http<CountryRules[]>(`${base}/customers/${customerId}/${encodeURIComponent(countryCode)}`, { method: "PUT", body: JSON.stringify(body) }),
  deleteCustomer: (customerId: number, countryCode: string) =>
    http<CountryRules[]>(`${base}/customers/${customerId}/${encodeURIComponent(countryCode)}`, { method: "DELETE" }),

  countries: () => http<RoutingCountry[]>(`${base}/countries`),
  check: (customerId: number, number: string) =>
    http<RouteCheckResult>(`${base}/check?customerId=${customerId}&number=${encodeURIComponent(number)}`),
};
